export const Terms = {
  privacy:
    "https://intercom.help/innovationlabs/en/articles/16908966-dropshiptool-s-privacy-policy",
  terms:
    "https://intercom.help/innovationlabs/en/articles/16908929-dropshiptool-s-terms-of-service",
  refund:
    "https://intercom.help/innovationlabs/en/articles/16908921-what-is-dropshiptool-s-refund-policy",
};
